export function genereerWerkbonNummer() {
  const now = new Date();
  const jaar = now.getFullYear();
  const maand = String(now.getMonth() + 1).padStart(2, "0");
  const dag = String(now.getDate()).padStart(2, "0");
  const tijd = String(Date.now()).slice(-6);
  const random = String(Math.floor(1000 + Math.random() * 9000));
  return `WB-${jaar}${maand}${dag}-${tijd}${random}`;
}
